<template>
  <SbIconButton
    class="sb-modal__close-button"
    tooltip-position="top"
    icon="x"
    size="small"
    :label="i18n(locale, 'Close Modal')"
    @click="handleCloseModal"
  />
</template>

<script setup lang="ts">
import SbIconButton from '../../IconButton'
import i18n, { type Locale } from '../../../i18n'

export type SbModalCloseButtonProps = {
  locale?: Locale
}

export type SbModalCloseButtonEmits = {
  (e: 'click'): void
}

const emit = defineEmits<SbModalCloseButtonEmits>()

withDefaults(defineProps<SbModalCloseButtonProps>(), {
  locale: 'en',
})

function handleCloseModal(): void {
  emit('click')
}
</script>
